import { c as _c } from "react/compiler-runtime";
import type { CSSProperties } from "react";
export type VideoProps = {
  ariaLabel?: string;
  autoplay?: boolean;
  className?: string;
  controls?: boolean;
  domAttrs?: Record<string, unknown>;
  height?: number;
  loop?: boolean;
  muted?: boolean;
  playsInline?: boolean;
  posterSrc?: string;
  preload?: "none" | "metadata" | "auto";
  src?: string;
  style?: CSSProperties;
  width?: number;
};

/**
 * Self-hosted `<video>`, shared by the editor canvas and the public site.
 *
 * Two rules are enforced here rather than left to the author, because getting either wrong
 * produces a video that silently never plays:
 *
 * 1. **autoplay implies muted + playsInline.** Every current browser blocks unmuted autoplay,
 *    and iOS takes an un-inlined video fullscreen. An autoplaying clip authored without both
 *    simply does nothing, with no error anywhere.
 * 2. **No source, no element.** An empty `<video>` paints a black box. Render the poster alone
 *    if there is one, otherwise nothing — a missing asset should read as absent, not broken.
 */
export function Video(t0) {
  const $ = _c(29);
  const {
    ariaLabel,
    autoplay,
    className,
    controls: t1,
    domAttrs,
    height,
    loop,
    muted,
    playsInline,
    posterSrc,
    preload: t2,
    src,
    style,
    width
  } = t0;
  const controls = t1 === undefined ? true : t1;
  const preload = t2 === undefined ? "metadata" : t2;
  let t3;
  if ($[0] !== posterSrc) {
    t3 = posterSrc?.trim() || undefined;
    $[0] = posterSrc;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const poster = t3;
  let t4;
  if ($[2] !== src) {
    t4 = src?.trim() || undefined;
    $[2] = src;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const source = t4;
  if (!source) {
    if (!poster) {
      return null;
    }
    const t5 = ariaLabel || "";
    let t6;
    if ($[4] !== className || $[5] !== domAttrs || $[6] !== height || $[7] !== poster || $[8] !== style || $[9] !== t5 || $[10] !== width) {
      t6 = <img alt={t5} className={className} height={height} src={poster} style={style} width={width} {...domAttrs} />;
      $[4] = className;
      $[5] = domAttrs;
      $[6] = height;
      $[7] = poster;
      $[8] = style;
      $[9] = t5;
      $[10] = width;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    return t6;
  }
  let t5;
  if ($[12] !== ariaLabel) {
    t5 = ariaLabel ? {
      "aria-label": ariaLabel
    } : {};
    $[12] = ariaLabel;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const t6 = autoplay === true;
  const t7 = controls !== false;
  const t8 = loop === true;
  const t9 = autoplay === true || muted === true;
  const t10 = autoplay === true || playsInline === true;
  let t11;
  if ($[14] !== className || $[15] !== domAttrs || $[16] !== height || $[17] !== poster || $[18] !== preload || $[19] !== source || $[20] !== style || $[21] !== t10 || $[22] !== t5 || $[23] !== t6 || $[24] !== t7 || $[25] !== t8 || $[26] !== t9 || $[27] !== width) {
    t11 = <video {...t5} autoPlay={t6} className={className} controls={t7} height={height} loop={t8} muted={t9} playsInline={t10} poster={poster} preload={preload} src={source} style={style} width={width} {...domAttrs} />;
    $[14] = className;
    $[15] = domAttrs;
    $[16] = height;
    $[17] = poster;
    $[18] = preload;
    $[19] = source;
    $[20] = style;
    $[21] = t10;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
    $[27] = width;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  return t11;
}